<template>
  <div class="details">
    <div>
      <div class="container">
        <h1>{{ propagateDetails.title }}</h1>
        <div class="userInfo">
          <van-icon :size="20" name="user-circle-o"/>
          <div class="keywords">
            <p>{{ propagateDetails.createName }}</p>
            <span v-for="(tap, index) in propagateDetails.keywords" :key="index">{{ tap }}</span>
          </div>
        </div>
        
      </div>
      <div class="article">
        <article v-html="propagateDetails.content"></article>
      </div>
    </div>
  </div>
</template>
<script>
import { propagateDetails } from "@/api/propagate/propagate";
export default {
  data() {
    return {
      propagateDetails: '',
      id: this.$route.params.id,
    };
  },
  created () {
    this.getDetails();
  },
  methods: {
    getDetails() {
      propagateDetails({id: this.id}).then(v => {
        const data = v.data;
        data.keywords = JSON.parse(data.keywords);
        this.propagateDetails = v.data;
      });
    },
  },
};
</script>
<style lang="scss">
.details {
  padding: 24px;
  .container {
    margin: 0 auto;
  }
  h1 {
    font-size: 20px;
  }
  .userInfo {
    vertical-align: middle;
    margin-bottom: 10px;
    i, p {
      vertical-align: middle;
    }
    i{
      margin-right: 5px;
    }
  }
  .article {
    margin: 0 auto;
  }
  .keywords {
    display: inline-block;
    vertical-align: middle;
    span {
      color:#999;
      padding-right: 10px;
    }
  }
}
</style>